import { useEffect } from "react";
import { SITE_ORIGIN, OG_IMAGE } from "@/lib/jsonld";

const JSONLD_ID_PREFIX = "hds-jsonld-";

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertCanonical(href) {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

function clearJsonLd() {
    document.head
        .querySelectorAll(`script[data-jsonld^="${JSONLD_ID_PREFIX}"]`)
        .forEach((el) => el.remove());
}

function appendJsonLd(blocks) {
    blocks.forEach((block, i) => {
        const el = document.createElement("script");
        el.setAttribute("type", "application/ld+json");
        el.setAttribute("data-jsonld", `${JSONLD_ID_PREFIX}${i}`);
        el.textContent = JSON.stringify(block);
        document.head.appendChild(el);
    });
}

/**
 * Sets per-page title, meta description, canonical, Open Graph tags and
 * JSON-LD structured data. Canonical + og:url always resolve against the real
 * production domain so the deploy's prerender emits the correct URL.
 */
export default function useSeo({ title, description, path, jsonLd } = {}) {
    useEffect(() => {
        if (title) document.title = title;
        upsertMeta("name", "description", description);

        const pathname = path || window.location.pathname || "/";
        const canonical = SITE_ORIGIN + pathname;
        upsertCanonical(canonical);

        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", canonical);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "Human Design Studio");
        upsertMeta("property", "og:image", OG_IMAGE);
        upsertMeta("name", "twitter:card", "summary_large_image");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);
        upsertMeta("name", "twitter:image", OG_IMAGE);

        clearJsonLd();
        if (Array.isArray(jsonLd) && jsonLd.length) {
            appendJsonLd(jsonLd);
        }

        return clearJsonLd;
    }, [title, description, path, jsonLd]);
}
